// Dependencies
var _ = require('underscore');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');

// App
var ErrorView = require('app/common/views/error-view');

// Channels
var channel = Radio.channel('global');

var ShowError = Marionette.Object.extend({
    initialize: function() {
        // Render an error page to the passed region
        channel.reply('show:error', function(region, options) {
            /* Options
            {
                errorCode: 404,
                message: 'HELLO I AM A CUSTOM ERROR MESSAGE'
            }
            */

            if (_.isUndefined(region)) {
                throw new Error('region required to show error');
            }

            var errorView = new ErrorView(options);
            region.show(errorView);
        });

        // Return view without rendering it
        channel.reply('get:error', function(options) {
            return new ErrorView(options);
        });
    },
    destroy: function() {
        channel.stopReplying('show:error');
        channel.stopReplying('get:error');
    },
});

module.exports = ShowError;
